import { render } from "./User.vue?vue&type=template&id=65e83e96&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=65e83e96&lang=less&scoped=true"

import exportComponent from "D:\\project\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e83e96"]])

export default __exports__